export const COMPLETION_KEY = "`";
